import script from "./Call.vue?vue&type=script&setup=true&lang=ts"
export * from "./Call.vue?vue&type=script&setup=true&lang=ts"

import "./Call.vue?vue&type=style&index=0&id=c9c5e720&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9c5e720"]])

export default __exports__